import Fee from "ts/api/fee";
import { OrderProduct } from "ts/api/order";
import { FullProduct } from "ts/api/product";
import { getDiscountAmount } from "view/apps/Exhibitor/pages/Cart/helpers";

export const calculateSubtotal = (
  products: (OrderProduct | FullProduct)[],
  fees: Fee[],
  withFees = true
) => {
  const productsAmount = products.reduce((acc, cur) => {
    const productPrice =
      (withFees ? cur.priceWithFees : cur.price) * cur.quantity;
    const extraPrices = cur?.extras?.length
      ? cur?.extras.reduce(
          (sum, extraProduct) =>
            sum +
            (withFees ? extraProduct.priceWithFees : extraProduct.price) *
              extraProduct.quantity,
          0
        )
      : 0;

    return acc + extraPrices + productPrice;
  }, 0);

  const discountAmount = getDiscountAmount(products, withFees);

  const feesAmount = fees?.length
    ? fees.reduce((acc, cur) => {
        const amount = withFees ? cur?.amountWithFees || 0 : cur.amount;
        return acc + amount;
      }, 0)
    : 0;

  return Math.max(0, productsAmount - discountAmount) + feesAmount;
};
